var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSummarize1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_3355)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 2.27148H3.33333C2.6 2.27148 2.00667 2.87148 2.00667 3.60482L2 12.9382C2 13.6715 2.59333 14.2715 3.32667 14.2715H12.6667C13.4 14.2715 14 13.6715 14 12.9382V6.27148L10 2.27148ZM3.33333 12.9382V3.60482H9.33333V6.93815H12.6667V12.9382H3.33333ZM6 5.60482C6 5.97148 5.7 6.27148 5.33333 6.27148C4.96667 6.27148 4.66667 5.97148 4.66667 5.60482C4.66667 5.23815 4.96667 4.93815 5.33333 4.93815C5.7 4.93815 6 5.23815 6 5.60482ZM6 8.27148C6 8.63815 5.7 8.93815 5.33333 8.93815C4.96667 8.93815 4.66667 8.63815 4.66667 8.27148C4.66667 7.90482 4.96667 7.60482 5.33333 7.60482C5.7 7.60482 6 7.90482 6 8.27148ZM6 10.9382C6 11.3048 5.7 11.6048 5.33333 11.6048C4.96667 11.6048 4.66667 11.3048 4.66667 10.9382C4.66667 10.5715 4.96667 10.2715 5.33333 10.2715C5.7 10.2715 6 10.5715 6 10.9382Z",
    fill: "#9334E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_3355"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.271484)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSummarize1);
export default __webpack_public_path__ + "static/media/Summarize1.ef84f8e48eeb8e1381fac0e767004414.svg";
export { ForwardRef as ReactComponent };